import React from 'react';
import { useIntl } from 'react-intl';

import { Graphic, Period } from '../../../hooks/types';
import { Charts } from '../../ui';
import { GraphicTitle, GraphicWrapper } from '../style';

export type UpdateAnalyticsProps = {
  date: Period;
  loginProject: string | null;
  country: string | null;
};

type Props = {
  authMethods: Graphic | null;
  rangeTitle: string;
  error: boolean;
};

export const getState = (body: Graphic | null, error: boolean): 'fail' | 'empty' | 'normal' => {
  if (error) {
    return 'fail';
  }
  if (!body || body.points.length === 0) {
    return 'empty';
  }
  return 'normal';
};

const AuthMethodsGraphic = ({ authMethods, error, rangeTitle }: Props): JSX.Element => {
  const intl = useIntl();

  const stackFormatter = (total: string | bigint | number) => {
    return intl.formatNumber(Number(total));
  };

  return (
    <GraphicWrapper>
      <GraphicTitle data-test-id="analytics-page__auth-methods__title">
        {intl.formatMessage({ id: 'analytics.charts.auth-methods' })}
      </GraphicTitle>
      <Charts
        name="auth-methods"
        state={getState(authMethods, error)}
        options={{
          chart: {
            type: 'column'
          },
          legend: {
            enabled: false
          },
          tooltip: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            header: rangeTitle,
            total: authMethods ? authMethods.total : 0,
            valueFormatter: (value: bigint | number) => intl.formatNumber(value)
          },
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          yAxis: {
            title: {
              text: intl.formatMessage({ id: 'analytics.charts.auth-methods.legend' }),
              align: 'high',
              offset: 0,
              rotation: 0,
              x: -20,
              textAlign: 'left',
              reserveSpace: false,
              y: -6
            },
            stackLabels: {
              formatter: stackFormatter
            },
            showLastLabel: false,
            offset: -20,
            labels: {
              y: -6,
              align: 'left'
            },
            minRange: 4,
            min: 0
          },
          xAxis: {
            categories: authMethods
              ? authMethods.points.map(
                  (p) => intl.formatMessage({ id: `auth-methods.${p.key}` }) || p.key
                )
              : []
          },
          series: [
            {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              data: authMethods ? authMethods.points.map((p) => p.value) : [],
              maxPointWidth: 72
            }
          ]
        }}
      />
    </GraphicWrapper>
  );
};

export default AuthMethodsGraphic;
